/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pipelines_ColorInputs */

const cs_pipelines_color = /** @type {(inputs: Pipelines_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Barva`)
};

const en_pipelines_color = /** @type {(inputs: Pipelines_ColorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Color`)
};

/**
* | output |
* | --- |
* | "Color" |
*
* @param {Pipelines_ColorInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const pipelines_color = /** @type {((inputs?: Pipelines_ColorInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pipelines_ColorInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pipelines_color(inputs)
	return cs_pipelines_color(inputs)
});